const PLATFORM_ALIASES = {
    "web.g5en": "browser_game",
    "g5en": "web",
};

const getPlatformFromId = (id) => {
    const raw = id?.match(/com\.g5e\.[^.]+\.(web\.g5en|[^.]+)/)?.[1];
    return PLATFORM_ALIASES[raw] || raw;
};

export default getPlatformFromId;
